/*! jquery-dateformat 01-08-2019 */

var DateFormat = {};
!(function (e) {
  var I = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    O = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    v = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    w = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    a = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    },
    u = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.?\d{0,3}[Z\-+]?(\d{2}:?\d{2})?/;
  DateFormat.format = (function () {
    function o(e) {
      return a[e] || e;
    }
    function i(e) {
      var a,
        r,
        t,
        n,
        s,
        o = e,
        i = "";
      return (
        -1 !== o.indexOf(".") &&
          ((o = (n = o.split("."))[0]), (i = n[n.length - 1])),
        3 <= (s = o.split(":")).length
          ? ((a = s[0]),
            (r = s[1]),
            (t = s[2].replace(/\s.+/, "").replace(/[a-z]/gi, "")),
            {
              time: (o = o.replace(/\s.+/, "").replace(/[a-z]/gi, "")),
              hour: a,
              minute: r,
              second: t,
              millis: i,
            })
          : { time: "", hour: "", minute: "", second: "", millis: "" }
      );
    }
    function D(e, a) {
      for (var r = a - String(e).length, t = 0; t < r; t++) e = "0" + e;
      return e;
    }
    return {
      parseDate: function (e) {
        var a,
          r,
          t = {
            date: null,
            year: null,
            month: null,
            dayOfMonth: null,
            dayOfWeek: null,
            time: null,
          };
        if ("number" == typeof e) return this.parseDate(new Date(e));
        if ("function" == typeof e.getFullYear)
          (t.year = String(e.getFullYear())),
            (t.month = String(e.getMonth() + 1)),
            (t.dayOfMonth = String(e.getDate())),
            (t.time = i(e.toTimeString() + "." + e.getMilliseconds()));
        else if (-1 != e.search(u))
          (a = e.split(/[T\+-]/)),
            (t.year = a[0]),
            (t.month = a[1]),
            (t.dayOfMonth = a[2]),
            (t.time = i(a[3].split(".")[0]));
        else
          switch (
            (6 === (a = e.split(" ")).length &&
              isNaN(a[5]) &&
              (a[a.length] = "()"),
            a.length)
          ) {
            case 6:
              (t.year = a[5]),
                (t.month = o(a[1])),
                (t.dayOfMonth = a[2]),
                (t.time = i(a[3]));
              break;
            case 2:
              (r = a[0].split("-")),
                (t.year = r[0]),
                (t.month = r[1]),
                (t.dayOfMonth = r[2]),
                (t.time = i(a[1]));
              break;
            case 7:
            case 9:
            case 10:
              t.year = a[3];
              var n = parseInt(a[1]),
                s = parseInt(a[2]);
              n && !s
                ? ((t.month = o(a[2])), (t.dayOfMonth = a[1]))
                : ((t.month = o(a[1])), (t.dayOfMonth = a[2])),
                (t.time = i(a[4]));
              break;
            case 1:
              (r = a[0].split("")),
                (t.year = r[0] + r[1] + r[2] + r[3]),
                (t.month = r[5] + r[6]),
                (t.dayOfMonth = r[8] + r[9]),
                (t.time = i(
                  r[13] + r[14] + r[15] + r[16] + r[17] + r[18] + r[19] + r[20]
                ));
              break;
            default:
              return null;
          }
        return (
          t.time
            ? (t.date = new Date(
                t.year,
                t.month - 1,
                t.dayOfMonth,
                t.time.hour,
                t.time.minute,
                t.time.second,
                t.time.millis
              ))
            : (t.date = new Date(t.year, t.month - 1, t.dayOfMonth)),
          (t.dayOfWeek = String(t.date.getDay())),
          t
        );
      },
      date: function (a, e) {
        try {
          var r = this.parseDate(a);
          if (null === r) return a;
          for (
            var t,
              n = r.year,
              s = r.month,
              o = r.dayOfMonth,
              i = r.dayOfWeek,
              u = r.time,
              c = "",
              h = "",
              l = "",
              m = !1,
              y = 0;
            y < e.length;
            y++
          ) {
            var d = e.charAt(y),
              f = e.charAt(y + 1);
            if (m)
              "'" == d
                ? ((h += "" === c ? "'" : c), (c = ""), (m = !1))
                : (c += d);
            else
              switch (((l = ""), (c += d))) {
                case "ddd":
                  (h += ((S = i), I[parseInt(S, 10)] || S)), (c = "");
                  break;
                case "dd":
                  if ("d" === f) break;
                  (h += D(o, 2)), (c = "");
                  break;
                case "d":
                  if ("d" === f) break;
                  (h += parseInt(o, 10)), (c = "");
                  break;
                case "D":
                  (h += o =
                    1 == o || 21 == o || 31 == o
                      ? parseInt(o, 10) + "st"
                      : 2 == o || 22 == o
                      ? parseInt(o, 10) + "nd"
                      : 3 == o || 23 == o
                      ? parseInt(o, 10) + "rd"
                      : parseInt(o, 10) + "th"),
                    (c = "");
                  break;
                case "MMMM":
                  (h +=
                    ((M = s), void 0, (g = parseInt(M, 10) - 1), w[g] || M)),
                    (c = "");
                  break;
                case "MMM":
                  if ("M" === f) break;
                  (h +=
                    ((k = s), void 0, (p = parseInt(k, 10) - 1), v[p] || k)),
                    (c = "");
                  break;
                case "MM":
                  if ("M" === f) break;
                  (h += D(s, 2)), (c = "");
                  break;
                case "M":
                  if ("M" === f) break;
                  (h += parseInt(s, 10)), (c = "");
                  break;
                case "y":
                case "yyy":
                  if ("y" === f) break;
                  (h += c), (c = "");
                  break;
                case "yy":
                  if ("y" === f) break;
                  (h += String(n).slice(-2)), (c = "");
                  break;
                case "yyyy":
                  (h += n), (c = "");
                  break;
                case "HH":
                  (h += D(u.hour, 2)), (c = "");
                  break;
                case "H":
                  if ("H" === f) break;
                  (h += parseInt(u.hour, 10)), (c = "");
                  break;
                case "hh":
                  (h += D(
                    (t =
                      0 === parseInt(u.hour, 10)
                        ? 12
                        : u.hour < 13
                        ? u.hour
                        : u.hour - 12),
                    2
                  )),
                    (c = "");
                  break;
                case "h":
                  if ("h" === f) break;
                  (t =
                    0 === parseInt(u.hour, 10)
                      ? 12
                      : u.hour < 13
                      ? u.hour
                      : u.hour - 12),
                    (h += parseInt(t, 10)),
                    (c = "");
                  break;
                case "mm":
                  (h += D(u.minute, 2)), (c = "");
                  break;
                case "m":
                  if ("m" === f) break;
                  (h += parseInt(u.minute, 10)), (c = "");
                  break;
                case "ss":
                  (h += D(u.second.substring(0, 2), 2)), (c = "");
                  break;
                case "s":
                  if ("s" === f) break;
                  (h += parseInt(u.second, 10)), (c = "");
                  break;
                case "S":
                case "SS":
                  if ("S" === f) break;
                  (h += c), (c = "");
                  break;
                case "SSS":
                  (h += D(u.millis.substring(0, 3), 3)), (c = "");
                  break;
                case "a":
                  (h += 12 <= u.hour ? "PM" : "AM"), (c = "");
                  break;
                case "p":
                  (h += 12 <= u.hour ? "p.m." : "a.m."), (c = "");
                  break;
                case "E":
                  (h += ((b = i), O[parseInt(b, 10)] || b)), (c = "");
                  break;
                case "'":
                  (c = ""), (m = !0);
                  break;
                default:
                  (h += d), (c = "");
              }
          }
          return (h += l);
        } catch (e) {
          return console && console.log && console.log(e), a;
        }
        var b, k, p, M, g, S;
      },
      prettyDate: function (e) {
        var a, r, t, n, s;
        if (
          (("string" != typeof e && "number" != typeof e) || (a = new Date(e)),
          "object" == typeof e && (a = new Date(e.toString())),
          (r = (new Date().getTime() - a.getTime()) / 1e3),
          (t = Math.abs(r)),
          (n = Math.floor(t / 86400)),
          !isNaN(n))
        )
          return (
            (s = r < 0 ? "from now" : "ago"),
            t < 60
              ? 0 <= r
                ? "just now"
                : "in a moment"
              : t < 120
              ? "1 minute " + s
              : t < 3600
              ? Math.floor(t / 60) + " minutes " + s
              : t < 7200
              ? "1 hour " + s
              : t < 86400
              ? Math.floor(t / 3600) + " hours " + s
              : 1 === n
              ? 0 <= r
                ? "Yesterday"
                : "Tomorrow"
              : n < 7
              ? n + " days " + s
              : 7 === n
              ? "1 week " + s
              : n < 31
              ? Math.ceil(n / 7) + " weeks " + s
              : "more than 5 weeks " + s
          );
      },
      toBrowserTimeZone: function (e, a) {
        return this.date(new Date(e), a || "MM/dd/yyyy HH:mm:ss");
      },
    };
  })();
})(),
  (jQuery.format = DateFormat.format);

$(document).ready(function () {
  //Write your code below this line

  const toTimestamp = (strDate) => {
    const dt = Date.parse(strDate);
    return dt / 1000;
  };
  theme.utils.pretty_time_string = function (num) {
    return (num < 10 ? "0" : "") + num;
  };

  theme.utils.htmlParsing = function () {
    $('[data-html-parse="true"]').each(function (index) {
      var wrapper = $(this);
      wrapper.html(wrapper.text());
    });
  };
  function addWeekdaysToDate(date, numberToAdd) {
    var isValid = function (d) {
      return d.getDay() !== 0;
    };
    if (Math.abs(numberToAdd) > 1) {
      return addWeekdaysToDate(
        addWeekdaysToDate(date, Math.sign(numberToAdd)),
        numberToAdd - Math.sign(numberToAdd)
      );
    } else if (Math.abs(numberToAdd) === 1) {
      var result = new Date(date);
      result.setDate(result.getDate() + Math.sign(numberToAdd));
      if (isValid(result)) {
        return result;
      } else {
        return addWeekdaysToDate(result, Math.sign(numberToAdd));
      }
    } else if (numberToAdd === 0) {
      return date;
    }
    return false;
  }
  var getTimeLeft = function (diffInSeconds) {
    var hours = parseInt(diffInSeconds / 3600);
    var minutes = parseInt((diffInSeconds % 3600) / 60);
    var seconds = parseInt((diffInSeconds % 3600) % 60);

    return (
      (hours ? hours + (hours > 1 ? " hours " : " hour ") : "") +
      (minutes ? minutes + " min. " : "") +
      seconds +
      " sec."
    );
  };
  theme.utils.pdp_estimate_delivery = function () {
    var weekdays = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    var eta_delivery_days = theme.eta_delivery_days;
    var ukTime0 = moment().tz("Europe/London");
    $(".next_eta_date").empty();
    var dt = ukTime0;
    var day = dt.day();
    var uk_hrs0 = dt.get("hour");
    //     console.log('Today: '+weekdays[day], dt.get('hour'))
    //   var date = dt.getDate();
    try {
      var nextETADate = new Date();
      if (dt.get("hour") < 12) {
        if (dt.day() == 4) {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          //         console.log('<12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          nextETADate2 = new Date(addWeekdaysToDate(dt, 1));
          //         console.log('< 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
        } else if (dt.day() == 5) {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          //         console.log('<12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          nextETADate2 = new Date(addWeekdaysToDate(dt, 2));
          //         console.log('< 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
        } else if (dt.day() == 6) {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          //         console.log('<12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          nextETADate2 = new Date(addWeekdaysToDate(dt, 2));
          //         console.log('< 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
        } else if (dt.day() == 0) {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          //         console.log(nextETADate2)
          //         console.log('<12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          nextETADate2 = new Date(addWeekdaysToDate(dt, 2));
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
          //         console.log('< 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
        } else {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 2));
          //         console.log('<12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          nextETADate2 = new Date(addWeekdaysToDate(dt, 1));
          //         console.log('< 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
        }
      } else {
        //After 12pm
        //       console.log('After 12pm-------')
        if (dt.day() == 4) {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 4));
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          //         console.log('>12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
          //         console.log('> 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
        } else if (dt.day() == 5) {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 4));
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          //         console.log('>12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
          //         console.log('> 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
        } else if (dt.day() == 6) {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          //         console.log('>12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          nextETADate2 = new Date(addWeekdaysToDate(dt, 2));
          //         console.log('> 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
        } else if (dt.day() == 0) {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          //         console.log('>12 Our Next Estimated Delivery Date Is: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          nextETADate2 = new Date(addWeekdaysToDate(dt, 2));
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
          //         console.log('> 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
        } else {
          var nextETADate2 = new Date(addWeekdaysToDate(dt, 3));
          //         console.log('> 12 Our Next Estimated Delivery Date Is: '+nextETADate2.getDay()+" "+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
          $(".next_eta_date").text($.format.date(nextETADate2, "ddd dd MMMM"));
          nextETADate2 = new Date(addWeekdaysToDate(dt, 2));
          $(".next_eta_date2").text($.format.date(nextETADate2, "ddd dd MMMM"));
          //         console.log('> 12 Expedited Shipping At Checkout For Delivery On: '+weekdays[nextETADate2.getDay()] +" "+nextETADate2.getDate() + " " +monthNames[nextETADate2.getMonth()])
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  theme.utils.header_two_day_delivery = function () {
    var now_time1 = theme.current_datetime;
    var Curernt_Time = moment.tz(now_time1 + " 12:00:00", "Europe/London");
    // 24 hour clock
    if (true) {
      var x = setInterval(function () {
        // Get today's date and time
        var now = new Date().getTime();
        // Find the distance between now and the count down date
        var distance = Curernt_Time - now;
        //         console.log(Curernt_Time,now)
        // 		console.log()
        var hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // console.log(hours,minutes)
        // Compose the string for display
        var currentTimeString =
          theme.utils.pretty_time_string(hours) +
          ":" +
          theme.utils.pretty_time_string(minutes) +
          ":" +
          theme.utils.pretty_time_string(seconds);
        $("#remaining_time,.remaining_time").html(
          "order in " + currentTimeString
        );
        $(".order-timer-remaining").html(getTimeLeft(distance / 1000));

        // If the count down is finished, write some text
        //             console.log(distance)
        if (distance < 0) {
          clearInterval(x);
          // $("#remaining_time,.remaining_time").html('For shipping timeframes and product shelf life. <span><a href="javascript:;" class="js-no-transition">Learn more</a></span>');
          // $('.order-timer-text').html('For shipping timeframes and product shelf life. <span><a href="javascript:;" class="js-no-transition">Learn more</a></span>');
          $("#remaining_time,.remaining_time").html("order before midday.");
          $(".order-timer-remaining").html("order before midday.");
        }
      }, 1000);
    }
  };

  theme.utils.custom_videos_init = function (eles) {
    var videos = document.querySelectorAll(eles);
     if(!$('body').hasClass('is-ios-device') && !$('body').hasClass('ipad') && !$('body').hasClass('mac')){
    videos.forEach((element) => {
      var parent = element;
      if (parent) {
        let video = parent.querySelector(".js-video-element"),
          content_texts = parent.nextElementSibling;
        if (!video) return;
        let playbtn = parent.querySelector(".js-play-btn");
        let loop = video.hasAttribute("loop");
        if (video && playbtn) {
          let isPlayed = false;
          playbtn.addEventListener("click", function (e) {
            //             console.log(video.paused)
            if (video.paused == true) {
              if (isPlayed == false) {
                video.load();
              }
              video.play();
              isPlayed = true;
              playbtn.style.display = "none";
              if (content_texts) {
                content_texts.style.display = "none";
              }
            }
          });
          video.addEventListener("click", function (e) {
            console.log(video.paused);
            if (video.paused == false) {
              playbtn.style.display = "flex";
            } else {
              playbtn.style.display = "none";
            }
            //             if(video.paused == true){
            //               video.play();
            //               playbtn.style.display='flex';
            // //               if(content_texts){
            // //                 content_texts.style.display='block';
            // //               }
            //             }
            //             else{
            //               video.play();
            //               if(content_texts){
            //                 content_texts.style.display='none';
            //               }

            //               playbtn.style.display='none';
            //             }
          });
          //           if(loop== false){
          //             addListenerMulti(video,'loadstart play playing', function(e){
          //               //               console.log(video.ended)
          //               if(video.ended){
          // //                 playbtn.style.display='flex';
          //                 if(content_texts){
          // //                   content_texts.style.display='block';
          //                 }
          //               }
          //             });
          //           }
        }
      }
    });
     }
  };

  // when a pouch is clicked on from the front-end,
  // add it to the box object as itemInBox
  function addItem(id) {
    var product = _box.productsForBox.find(function (product) {
      return product.id == id;
    });

    var item = {
      product: product.product,
      bagImage: product.image,
      displayName: product.displayName.trim(),
      count: 1,
      type: "pouch",
      properties: {
        _box_key: key,
      },
    };

    _box.pouchesAdded.push(item);

    // find and return the current existing object in the box
    // if undefined, then that pouch isn't in the box, so add a new line item
    function currentItem(currentItem) {
      if (currentItem.type == "pouch") {
        return currentItem.product["handle"] === product.product["handle"];
      }
    }

    var pouchInBox = _box.itemsInBox.find(currentItem);

    // if the product is in the box, update the count
    if (pouchInBox) {
      pouchInBox.count = pouchInBox.count + 1;
    } else {
      _box.itemsInBox.push(item);
    }
  }

  function removeItem(id) {
    var trimmed = false;
    var newPouches = _box.pouchesAdded.reduce(function (acc, pouch) {
      if (trimmed || pouch.product.id != id) {
        acc.push(pouch);
      }
      if (pouch.product.id == id) {
        trimmed = true;
      }
      return acc;
    }, []);

    _box.pouchesAdded = newPouches;

    var pouchInBox = _box.itemsInBox.find(function (item) {
      return item.product.id == id;
    });

    // if the product is in the box, update the count
    if (pouchInBox.count > 1) {
      pouchInBox.count = pouchInBox.count - 1;
    } else {
      _box.itemsInBox = _box.itemsInBox.filter(function (item) {
        return item.product.id != id;
      });
    }
  }

  theme.utils.customTabs = function () {
    $(".tabs li a:not(:first)").addClass("inactive");
    $(".tab_container").hide();
    $(".tab_container:first").show();
    var mobile_place =
      $(".tabs-wrapper").attr("data-mobile-placement-change") || false;

    if ($(window).width() < 769) {
      if (mobile_place == "true" || mobile_place == true) {
        $(".tabs-wrapper ul li:not(.table-btn)").each(function (indx) {
          var ele = $(this);
          var id = $(this).find("a").attr("data-id"),
            tab = $("#" + id).clone();
          // console.log(tab)
          ele.append(tab.hide());
        });
        if ($(".tab_container:eq(0)").is(":visible") == false) {
          $(".tab_container:eq(0)").show();
          $(".js-tab-trigger:eq(0)").addClass("active");
        }

        $(".tabs li a")
          .off("click")
          .on("click", function () {
            var t = $(this).attr("data-id");
            // $('.tabs li a').not($(this)).removeClass('active');
            $(this).toggleClass("active");
            // $('.tab_container').not($('#'+ t)).hide();
            $("#" + t).toggle();
            //         if($(this).hasClass('inactive')){
            //           //this is the start of our condition
            //           $('.tabs li a').addClass('inactive');
            //           $(this).removeClass('inactive');
            //         }
          });
      } else {
        $(".tabs-wrapper ul li:not(.table-btn)").each(function (indx) {
          var ele = $(this);
          var id = $(this).find("a").attr("data-id");
          $(this).find(".tab_container").remove();
        });
        if ($(".tab_container:eq(0)").is(":visible") == false) {
          $(".tab_container:eq(0)").show();
          $(".js-tab-trigger:eq(0)").addClass("active");
        }
        $(".tabs li a")
          .off("click")
          .on("click", function () {
            var parent = $(this).parents(".tabs-wrapper");
            var t = $(this).attr("data-id");
            var tab = $("#" + t);
            // console.log(parent.find(tab),t)
            if ($(this).hasClass("table-btn")) {
              $(".tab_container").hide();
              $(".js-tab-trigger").removeClass("active").addClass("inactive");
              $(this).addClass("active").removeClass("inactive");
              $("#" + t).show();
            } else {
              $(this).toggleClass("active");
              $("#" + t).toggle();
            }

            // if($(this).hasClass('active')){
            //   //this is the start of our condition
            //   // $('.tabs li a').addClass('inactive');
            //   $(this).removeClass('inactive');
            //   // $('.tab_container').hide();
            //   $('#'+ t).toggle();
            // }
          });
      }
    } else {
      $(".tabs-wrapper ul li:not(.table-btn)").each(function (indx) {
        var ele = $(this);
        var id = $(this).find("a").attr("data-id");
        $(this).find(".tab_container").remove();
      });
      $(".tab_container:eq(0)").show();
      $(".tabs li a")
        .off("click")
        .on("click", function () {
          var parent = $(this).parents(".tabs-wrapper");
          var t = $(this).attr("data-id");
          var tab = $("#" + t);
          //         console.log(parent.find(tab),t)
          if ($(this).hasClass("inactive")) {
            //this is the start of our condition
            $(".tabs li a").addClass("inactive");
            $(this).removeClass("inactive");
            $(".tab_container").hide();
            $("#" + t).fadeIn("slow");
          }
        });
    }
  };

  theme.utils.reminderPopupForm = function () {
    //remainder form validation

    if ($("body").hasClass("template-product")) {
      //Swal.fire({title:"Loading...",showConfirmButton:false,allowOutsideClick:false});
      $("#submit_reminder").prop("disabled", true);
      $.ajax({
        type: "GET",
        url: "https://reminderapp.stalwartdigital.com/public/api/getToken",
        dataType: "json",
        success: function (data) {
          //        console.log(data);
          var token = data.Response.data.token;
          $("#token").val(data.Response.data.token);
          if (data.Code == 201) {
            $("#submit_reminder").prop("disabled", false);
            Swal.close();
          }
          //        console.log(data.Response.data.token);
        },
        error: function (data, textStatus, jqXHR) {
          Swal.close();
          //process error msg
          console.log(data);
          console.log(textStatus);
          console.log(jqXHR);
        },
      });

      
      //    datepicker settings
      if ($("#reminder_date").length) {
        try {
          $("#reminder_date").datepicker({
            format: "dd/mm/yyyy",
            startDate: new Date(),
            zIndex: 99999,
            autoHide: true,
          });
        } catch (error) {}
        //       $("#reminder_date").datepicker({
        //         minDate: 0
        //       });
        //       $("#reminder_date").datepicker("option", "dateFormat", "yy/mm/dd");
        //    datepicker settings end
      }
      try {
        $("#remaindervalidation").validate({
          rules: {
            reminder_date: "required",
            name: "required",
            email: {
              required: true,
              email: true,
            },
            messsage: "required",
          },
          messages: {
            reminder_date: "Please enter date",
            name: "Please enter your name",
            email: "Please enter a valid email address",
            messsage: "Please enter message to go in you email for remainder",
          },
          submitHandler: function (form) {
            Swal.fire({
              title: "Saving...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            $("#submit_reminder").prop("disabled", true);
            //       form.submit();
            var formData = {
              sending_date: $("#reminder_date").val(),
              name: $("#name").val(),
              email: $("#email").val(),
              message: $("#message").val(),
              token: $("#token").val(),
              product_url: $("#product_url").val(),
              product_image_url: $("#product_image_url").val(),
              product_title: $("#product_title").val(),
              product_id: $("#product_id").val(),
            };
            console.log(formData);
            if ($("#token").val().length > 0) {
              $.ajax({
                type: "POST",
                url: "https://reminderapp.stalwartdigital.com/public/api/addRemainder",
                data: formData,
                dataType: "json",
                success: function (data) {
                  console.log("from submitdata");
                  console.log(data);

                  if (data.Code == 200) {
                    Swal.close();
                    $(".reminder-form").hide();
                    $(".thanx-msg").show();
                    $("span#remider_date").text($("#reminder_date").val());
                    $("#remaindervalidation")[0].reset();

                    $("#submit_reminder").prop("disabled", false);
                  }
                },
                error: function (data, textStatus, jqXHR) {
                  //process error
                  Swal.close();
                  $(".reminder-form").show();
                  $(".thanx-msg").hide();
                  console.log(data);
                  console.log(textStatus);
                  console.log(jqXHR);
                },
                // encode: true,
              }).done(function (data) {});
            } else {
              alert("Invalid Request, please try again later");
            }
          },
        });
      } catch (error) {}
    }
  };

  theme.utils.footerMenuToggle = function () {
    if ($(window).width() < 769) {
      $(document)
        .off("click")
        .on("click", ".inner-collumn h4", function () {
          var trigger = $(this),
            parent = trigger.parents(".inner-collumn"),
            eleToToggle = parent.find(".toggle_list");
          trigger.toggleClass("slide-up");
          eleToToggle.slideToggle();
        });
    }
  };

  theme.utils.header_two_day_delivery();
  theme.utils.custom_videos_init(".js-video-wrapper");
  theme.utils.AddReadMore();
  theme.utils.htmlParsing();
  if ($("body").hasClass("template-product")) {
    theme.utils.pdp_estimate_delivery();
  }
  theme.utils.customTabs();
  theme.utils.reminderPopupForm();
  $(document).on("quickview:loaded", function () {
    theme.utils.customTabs();
  });
  theme.utils.footerMenuToggle();

  try {
        if ($("#contactFormEvent").length) {
          // console.log('datapicker')
          $("#contactFormEvent").datepicker({
            format: "dd/mm/yyyy",
            startDate: new Date(),
            zIndex: 99999,
            autoHide: true,
          });
          //    datepicker settings end
        }
      } catch (error) {}
  if ($("#cart_datepicker").length > 0) {
    try {
      $("#cart_datepicker").datepicker({
        format: "dd/mm/yyyy",
        startDate: new Date(),
        zIndex: 99999,
        autoHide: true,
      });
    } catch (error) {}
  }
  $(document).on("click", ".js-desktop-filter-trigger", function () {
    $(".js-product-grid").toggleClass("js-product-grid-enlarge");
    $(".js-desktop-filter-hide").toggleClass("hide");
    if (!theme.config.isTouch)
      window.scrollTo(
        0,
        $('[data-section-type="collection-template"]').offset().top - 140
      );
  });

  var shippingTimerPopup = new theme.Modals(
    "ShippingTimerPopup",
    "ShippingTimer-popup",
    {
      closeOffContentClick: true,
      bodyOpenClass: ["modal-open", "shipping-modal-open"],
      solid: true,
    }
  );
  $("body").on("click", "div#js-shipping-timer a", function (e) {
    e.preventDefault();
    shippingTimerPopup.open();
  });

  var reminderPopup = new theme.Modals("ReminderPopup", "Reminder-popup", {
    closeOffContentClick: true,
    bodyOpenClass: ["modal-open", "shipping-modal-open"],
    solid: true,
  });
  $("body").on("click", ".reminder-popup-trigger", function (e) {
    e.preventDefault();
    reminderPopup.open();
  });

  $("#empty_basket").on("click", function (e) {
    e.preventDefault();
    $(this).text("Please wait...").attr("disabled", "disabled");
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      data: "",
      dataType: "json",
      success: function () {
        $("#empty_basket").text("Empty My Basket").removeAttr("disabled");
        location.reload();
      },
      error: function (XMLHttpRequest, textStatus) {
        /* error code */
      },
    });
  });

  function register($form) {
    //       console.log($form.serialize())
    $.ajax({
      type: $form.attr("method"),
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      error: function (err) {
        console.log(err);
      },
      success: function (data) {
        console.log($form.serialize());
        if (data.result === "success") {
          // Yeahhhh Success
          console.log(data.msg);
        } else {
          // Something went wrong, do something to notify the user.
          console.log(data.msg);
        }
      },
    });
  }
  $(
    'body.page-corporate-gifting form.corporate-gifting-form input[type="submit"]'
  ).on("click", function (e) {
    if ($("#ContactFormchkbx2").prop("checked")) {
      $("form#gifiting-register-subscribe-form input#mce-EMAIL").val(
        $(
          "body.page-corporate-gifting form#contact_form input#contactFormEmail"
        ).val()
      );
      $("form#gifiting-register-subscribe-form input#mce-CORPGIFT").val("Yes");
      var $form = $("form#gifiting-register-subscribe-form");
      register($form);
    } else {
    }
  });

  if (theme.customer_logged_in) {
    var detailTrigger;
    detailTrigger = setInterval(CheckCustomerDetail, 1000);
    var refSet = false,
      linksSet = false;
    Date.prototype.getFormatDate = function () {
      var monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return (
        this.getMonth() + 1 + "/" + this.getDate() + "/" + this.getFullYear()
      );
    };
    function CheckCustomerDetail() {
      try {
        if (SweetTooth != undefined) {
          if (SweetTooth.customer != undefined) {
            if (SweetTooth.customer.referral_url != undefined) {
              //               $('#your_referall_code').html('<a href="'+SweetTooth.customer.referral_url+'">'+SweetTooth.customer.referral_url+'</a>');
              $("#your_referall_code").text(SweetTooth.customer.referral_url);
              refSet = true;
            }
            if (
              SweetTooth.customer.date_of_birth != undefined &&
              SweetTooth.customer.date_of_birth != null
            ) {
              console.log(SweetTooth.customer.date_of_birth);
              var dateFormat = new Date(
                SweetTooth.customer.date_of_birth
              ).getFormatDate();
              $("#birthdayValue").html(dateFormat);
              linksSet = true;
              $(".birthday-col").show();
              $("#birthdayValue").show();
            } else {
              $(".birthday-col").show();
              $("#lnkAddBirthday").show();
            }
          }
          //         if(SweetTooth.customerAuthenticationToken != undefined && SweetTooth.storefront_panel.id != undefined){
          //           $('#earn-point-url').attr('href','https://storefront-panel.sweettooth.io/with-nav/points-program-detail?channel_id=&customer_token='+SweetTooth.customerAuthenticationToken+'&storefront_panel_id='+SweetTooth.storefront_panel.id+'&tab=earnMore');
          //           $('#spend-point-url').attr('href','https://storefront-panel.sweettooth.io/with-nav/points-program-detail?channel_id=&customer_token='+SweetTooth.customerAuthenticationToken+'&storefront_panel_id='+SweetTooth.storefront_panel.id+'&tab=rewards');
          //           linksSet= true;
          //         }
        }
        if (refSet && linksSet) {
          clearInterval(detailTrigger);
        }
      } catch (err) {}
    }
    $(".copy-link-btn").click(function (e) {
      e.preventDefault();
      var copyText = document.getElementById("txtReferral");

      /* Select the text field */
      copyText.select();

      /* Copy the text inside the text field */
      document.execCommand("copy");
    });
  }
  var cookieAlert = document.querySelector(".cookie-alert");
  var acceptCookies = document.querySelector(".accept-cookies");

  cookieAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

  if (!getCookie("acceptCookies")) {
    cookieAlert.classList.add("show");
    $("body").addClass("cookie-showing");
  }

  acceptCookies.addEventListener("click", function () {
    setCookie("acceptCookies", true, 60);
    cookieAlert.classList.remove("show");
    $("body").removeClass("cookie-showing");
  });

  function onTidioChatApiReady() {
    // Code after chat loaded
    console.log("Tdio chat laoded");
    if ($("iframe#tidio-chat-iframe")) {
      $("iframe#tidio-chat-iframe").css({ "z-index": 999 });
    }
  }
  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady);
  } else {
    document.addEventListener("tidioChat-ready", onTidioChatApiReady);
  }

  if (window.SmileUI) {
    // SmileUI has loaded
  } else {
    document.addEventListener("smile-ui-loaded", () => {
      SmileUI.ready()
        .then((smileUiInstance) => {
          console.log("smile ui laoded");

          if ($("div#smile-ui-container")) {
            $("div#smile-ui-container").css({ "z-index": 999 });
          }
          // Smile UI has been fully intialized and is ready to be used.
          // smileUiInstance is an instance of the initialized variable, this is
          // synonymous to window.SmileUI.
        })
        .catch((err) => {
          // An error has occurred will intializing SmileUI
        });
      // SmileUI has loaded
    });
  }
  //Write your code above this line
});

// Cookie functions stolen from w3schools
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

KlaviyoSubscribe.attachToForms(
  "#blog-siderbar-newletter,#footer-signup-newsletter",
  {
    hide_form_on_success: true,
    success_message:
      "Success! Please check your email for a confirmation message.",
    extra_properties: {
      $source: "Recipes Newsletter",
      $method_type: "$embed",
      $method_id: "embed",
    },
    success: function ($form, data) {
      //           console.log(data)
      var email = $form.find('[name="email"]').val();
      var is_subscribed = data.is_subscribed;
      try {
        gtag("event", "sign_up", {
          userId: "",
          uemh: SHA256(email),
          method: "Footer Newsletter",
        });
      } catch (er) {
        console.log(er);
      }
      if (is_subscribed) {
        $form
          .siblings(".klaviyo_messages")
          .find(".success_message")
          .text("")
          .hide();
        $form
          .siblings(".klaviyo_messages")
          .find(".error_message")
          .text(
            `${email} is already subscribed to list Popcorn Shed Website Customer List.`
          )
          .show();
      } else {
        $form
          .siblings(".klaviyo_messages")
          .find(".error_message")
          .text("")
          .hide();
      }
      //           try{
      //             _learnq.push(['identify', { $email: email }]);
      //             _learnq.push(['track', 'Signed Up for Newsletter']);
      //           }
      //           catch(er){
      //             console.log(er)
      //           }
    },
  }
);

if (document.querySelector("#mc-embedded-subscribe-form-page")) {
    KlaviyoSubscribe.attachToForms("#mc-embedded-subscribe-form-page", {
      hide_form_on_success: true,
      success_message:
        "Success! Please check your email for a confirmation message.",
      extra_properties: {
        $source: "$embed",
        $method_type: "Newsletter landing page",
        $method_id: "embed",
      },
      success: function ($form, data) {
        //           console.log(data)
        var email = $form.find('[name="email"]').val();
        var is_subscribed = data.is_subscribed;
        try {
          gtag("event", "sign_up", {
            userId: "",
            uemh: SHA256(email),
            method: "Newsletter Landing Page",
          });
        } catch (er) {
          console.log(er);
        }
        if (is_subscribed) {
          $form
            .siblings(".klaviyo_messages")
            .find(".success_message")
            .text("")
            .hide();
          $form
            .siblings(".klaviyo_messages")
            .find(".error_message")
            .text(
              `${email} is already subscribed to list Popcorn Shed Website Customer List.`
            )
            .show();
        } else {
          $form
            .siblings(".klaviyo_messages")
            .find(".error_message")
            .text("")
            .hide();
        }
      },
    });
}
